'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateObs = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var duplicateObs = exports.duplicateObs = function duplicateObs(dims, observations) {
  var obsValues = R.values(observations);
  if (R.length(dims) === 0) {
    return observations;
  }
  var duplicated = R.reduce(function (obs, dim) {
    var groupedObs = R.groupBy(function (o) {
      return R.prop(dim.id, o.indexedDimValIds);
    }, obs);
    var enhancedObs = R.addIndex(R.map)(function (value, index) {
      var matchingObs = R.propOr([], value.id, groupedObs);
      return R.map(function (obs) {
        return R.over(R.lensProp('orderedDimIndexes'), function (_indexes) {
          var indexes = R.isNil(_indexes) ? R.map(function (i) {
            return Number(i);
          }, obs.dimValuesIndexes) : _indexes;
          return R.set(R.lensIndex(dim.__index), index)(indexes);
        })(obs);
      }, matchingObs);
    }, dim.values);
    return R.unnest(enhancedObs);
  }, obsValues, dims);
  var res = R.indexBy(R.pipe(R.prop('orderedDimIndexes'), R.join(':')), duplicated);
  return res;
};